import { render } from "./UserIconColored.vue?vue&type=template&id=b266b268"
import script from "./UserIconColored.vue?vue&type=script&lang=js"
export * from "./UserIconColored.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__